<div class="stack-section">
  <h2 class="section-title">Tech Stack</h2>
  <div class="stack-grid">
    @for (cat of techStack; track cat.category) {
    <mat-card class="stack-card" [class]="cat.cssClass" appearance="outlined">
      <mat-card-header>
        <mat-card-title class="category-title">{{ cat.category }}</mat-card-title>
        <span class="icon-badge">
          <mat-icon>{{ cat.icon }}</mat-icon>
        </span>
      </mat-card-header>
      <mat-divider></mat-divider>
      <div class="card-body">
        @for (tool of cat.tools; track tool) {
        <span class="tech-tag">{{ tool }}</span>
        }
      </div>
    </mat-card>
    }
  </div>
</div>
